/* unplugin-vue-components disabled */import script from "./text-media.vue?vue&type=script&lang=js"
export * from "./text-media.vue?vue&type=script&lang=js"

import "./text-media.vue?vue&type=style&index=0&id=5ac2514d&lang=scss"

const __exports__ = script;

export default __exports__